import { useRouter } from 'next/router';

export const useIsCrawler = () => {
  const { pathname } = useRouter();

  const doNotCrawlPaths =
    pathname.includes('search') ||
    pathname.includes('collections') ||
    pathname.includes('timeline');

  return {
    doNotCrawlPaths,
  };
};
